;(function () {
  window.Ateed.Components.LangPrompt = function() {
    function getAteedCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
    }
    function ateedSetCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = 0;
      if (exdays!=0) {
        expires = "expires="+ d.toUTCString();
      }
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    $('#lang_prompt .lang_prompt_container button.close,#lang_prompt .lang_prompt_container .lang_prompt_countries .lang_prompt_close').click(function(e){
      e.preventDefault();
      e.stopPropagation();
      ateedSetCookie('lang_prompt','1',0);
      $('#lang_prompt').fadeOut(function(){
        $(this).remove();
        $('body').css('margin-top','');
      });
    });
    function adjustBodyMarginTop() {
      $('body').css('margin-top',$('#lang_prompt').outerHeight()+'px');
      $('#lang_prompt').css('top',$('body').css('padding-top'));
    }
    function checkLangPromptHeight() {
      if ($('#lang_prompt').length>0) {
        if ($('#toolbar-administration').length>0) {
          setTimeout(function(){
            adjustBodyMarginTop();
          },500);
        }
        else {
          adjustBodyMarginTop();
        }
      }
    }
    if ($('#lang_prompt').length > 0) {
      $('.lang_prompt_countries > a').click(function(e){
        e.preventDefault();
        $.ajax({
            url: $(this).attr('data-url'),
            type: 'GET',
            dataType: "json",
            cache: false,
            crossDomain: true,
            async: true,
            xhrFields: {
                withCredentials: true
            },
            success: function(data){
              if (data) {
                if (data.url && data.langcode) {
                  //$.cookie('lang',data.langcode, { expires: 7, path: '/' });
                  ateedSetCookie('lang',data.langcode,7);
                  window.location = data.url;
                }
              }
            }
        });
      });
      if (getAteedCookie('lang_prompt')=='1' || getAteedCookie('lang')!='') {
        $('#lang_prompt').remove();
      }
      else {
        $.ajax({
            url: '/lang_prompt/country',
            type: 'GET',
            dataType: "json",
            cache: false,
            crossDomain: true,
            async: true,
            xhrFields: {
                withCredentials: true
            },
            success: function(data){
              if (data) {
                if (data.lang_prompt_country && data.lang_prompt_code) {
                  var code = data.lang_prompt_code.toLowerCase();
                  var show = false;

                  if ($('#lang_prompt .lang_prompt_countries_hidden > a').length >= 2) {
                    //var translationAvailable = false;
                    $('#lang_prompt .lang_prompt_countries_hidden > a').each(function(){
                      if ($(this).attr('data-langcode')) {
                        if ($(this).attr('data-langcode').indexOf(code)!=-1) {
                          //translationAvailable = true;
                          if ($(this).attr('data-isactive')!='1') {
                            $('#lang_prompt .lang_prompt_countries .lang_prompt_yes').attr('data-url',$(this).attr('data-url'));
                            show = true;
                            return false;
                          }
                        }
                      }
                    });
                    /*if (!translationAvailable) {
                      //show = true;
                      $('#lang_prompt .lang_prompt_countries > a').each(function(){
                        if ($(this).attr('data-langcode')=='en') {
                          show = true;
                          return false;
                        }
                      });
                    }*/
                  }
                  if (show) {
                    $('#lang_prompt #user_country').text(data.lang_prompt_country);
                    $('#lang_prompt #lang_version').text(data.lang_version);
                    $('#lang_prompt').show();
                    checkLangPromptHeight();
                    $(window).on('resize',function(){
                      checkLangPromptHeight();
                    });
                  }
                }
              }
            }
        });
      }
    }
  };
})();
